/*
 * Copyright © 2015-2018 Serenova, LLC. All rights reserved.
 */

import { isEmpty, isSerializedOrigin } from 'serenova-js-utils/strings';

const isValidHex = (hexString) => {
  if (!hexString) {
    return false;
  }
  const hexRegex = /^(#)?[0-9a-fA-F]{3,6}$/;
  /* Hex length should be 3 or 6 digits */
  const checkHexLength = /^(?:.{4}|.{7})$/; 
  return hexRegex.test(hexString) && checkHexLength.test(hexString);
}

const isValidColor = (colorComponent) => {
  return colorComponent !== null &&
    colorComponent !== undefined && (!isValidHex(colorComponent)
      && 'Please enter valid Hexadecimal Color Code');
}

export const formValidation = values => ({
  name: isEmpty(values.get('name')) && 'Please enter a name',
  contactPoint: isEmpty(values.get('contactPoint')) && 'Please enter a contact point',
  clientDisconnectMinutes:
    values.get('clientDisconnectMinutes') !== null &&
    values.get('clientDisconnectMinutes') !== undefined &&
    ((values.get('clientDisconnectMinutes') < 1 && 'Must be greater than or equal to 1') ||
      (values.get('clientDisconnectMinutes') > 1440 && 'Must be less than or equal to 1440')),
  buttonWidth: values.get('buttonWidth') !== null &&
    values.get('buttonWidth') !== undefined &&
    ((values.get('buttonWidth') < 10 && 'Must be greater than or equal to 10')),
  buttonHeight: values.get('buttonHeight') !== null &&
    values.get('buttonHeight') !== undefined &&
    ((values.get('buttonHeight') < 10 && 'Must be greater than or equal to 10')),
  brandColor: isValidColor(values.get('brandColor')),
  conversationColor: isValidColor(values.get('conversationColor')),
  actionColor: isValidColor(values.get('actionColor')),
  appId: isEmpty(values.get('appId')) && 'Please choose an app',
  whitelistedUrls:
    values.get('whitelistedUrls') &&
    values.get('whitelistedUrls').filter(url => !isSerializedOrigin(url)).size > 0 &&
    'One or more URL(s) are not properly formatted with serialized-origin standard.'
});
